<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11.2 6.4C11.5733 5.90222 12.2951 5.86904 12.7149 6.30044L12.8 6.4L18.8 14.4C19.272 15.0293 18.8648 15.9151 18.1101 15.9943L18 16H15V21C15 21.4734 14.6711 21.8699 14.2293 21.9736L14.1166 21.9933L14 22H10C9.48716 22 9.06449 21.614 9.00673 21.1166L9 21V16H6C5.25274 16 4.79631 15.2264 5.08642 14.5906L5.1385 14.4915L5.2 14.4L11.2 6.4ZM12 8.667L8 14H10C10.4734 14 10.8699 14.3289 10.9736 14.7707L10.9933 14.8834L11 15V20H13V15C13 14.5266 13.3289 14.1301 13.7707 14.0264L13.8834 14.0067L14 14H16L12 8.667ZM21 2C21.5523 2 22 2.44772 22 3C22 3.55228 21.5523 4 21 4H3C2.44772 4 2 3.55228 2 3C2 2.44772 2.44772 2 3 2H21Z"
    fill="currentColor"
  />
</svg>
